import { Icon } from '../ui/Icon';
import s from './ResultPanel.module.css';

export interface LocalResult {
  tone: 'ok' | 'warn' | 'bad';
  title: string;
  message: string;
  /** The sticker code, already formatted for reading aloud across a dock. */
  code?: string;
}

const ICON = { ok: 'check', warn: 'alert', bad: 'x' } as const;

/**
 * What just happened to the last scan. Green for a box that is in, amber for anything the worker
 * has to know about but need not act on — a duplicate, or a scan sitting in the queue.
 *
 * A refusal always takes the whole screen first, so it cannot be scrolled past; red is shown here
 * too, as what is left of that refusal once the flash has been dismissed, and for a queued scan
 * the server refuses later, when there was no flash to see.
 */
export function ResultPanel({ result }: { result: LocalResult | null }) {
  if (!result) return null;
  return (
    <div className={`result ${result.tone} ${s.resultCard}`} role="status" aria-live="polite">
      <span className="ico">
        <Icon name={ICON[result.tone]} />
      </span>
      <div className={s.resultBody}>
        <h4>{result.title}</h4>
        <p>{result.message}</p>
        {result.code && <p className={`mono ${s.resultCode}`}>{result.code}</p>}
      </div>
    </div>
  );
}
